import { DSSpacer } from '@zoe/ds-web'
import type { FC } from 'react'

import type { ModularLandingPageRecord } from '@/graphql/ModularLandingPage'

import { Footer } from '@/components/elements/footer/Footer'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

import { Header } from '@/elements/header/Header'

import { useSetTrackingSection } from '@/lib/hooks/useSetTrackingSection'

import { ModularLandingPageContent } from './ModularLandingPageContent'

type ModularLandingPageProps = {
  page: ModularLandingPageRecord
}

export const ModularLandingPage: FC<ModularLandingPageProps> = ({ page }) => {
  const { metaData, pageTitle } = page
  useSetTrackingSection('modular_landing_page')

  return (
    <>
      <SEOMetaTags metaData={{ ...metaData, title: pageTitle }} />
      <Header />
      <main>
        <DSSpacer direction="vertical" size={96} />
        <ModularLandingPageContent content={page.pageContent} />
      </main>
      <Footer showPreFooter={page.showPreFooter} />
    </>
  )
}
